/**
 * Enumerates the possible origins of an application error.
 *
 * Use this to distinguish whether an error was produced on the server
 * (e.g., HTTP/API failures, backend validation, infrastructure issues)
 * or on the client (e.g., UI logic faults, local validation failures,
 * network unavailability detected before a request is issued).
 *
 * Typical use cases:
 * - Drive conditional user messaging (e.g., suggest retry vs. fix input)
 * - Improve logging/telemetry segmentation
 * - Enable differentiated retry / fallback strategies
 *
 * @remarks
 * Keeping explicit origin metadata improves debuggability and supports
 * better observability dashboards and alert routing.
 *
 * @example
 * if (error.location === ErrorLocationEnum.Server) {
 *   notifyUserGenericServerIssue();
 * } else {
 *   focusFirstInvalidField();
 * }
 *
 * @public
 */

/** Error originated from the backend/server side (remote API, infrastructure, or integration). */

/** Error originated within the client application (browser/UI/runtime or pre-flight logic). */
export enum ErrorLocationEnum {
  Server = 'server',
  Client = 'client',
}
